import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getErrorBills = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getErrorBills()
}
